// Lightweight session-scoped draft for in-progress flight bookings
const KEY = "fa_flight_draft";

export const draftStore = {
  get() {
    try { return JSON.parse(sessionStorage.getItem(KEY) || "null"); } catch (_e) { return null; }
  },
  set(v) { sessionStorage.setItem(KEY, JSON.stringify(v)); },
  clear() { sessionStorage.removeItem(KEY); },
  patch(patch) {
    const cur = draftStore.get() || {};
    const next = { ...cur, ...patch };
    draftStore.set(next);
    return next;
  },
};

export function computeTotal(draft) {
  if (!draft) return 0;
  const pax = Number(draft.search?.passengers || 1);
  const segs = draft.selections || [];
  const baseAir = segs.reduce((s, sel) => s + (sel.flight?.price || 0) + (sel.fare?.price_delta || 0), 0) * pax;
  const anc = draft.ancillaries || {};
  let extras = 0;
  // Seats: per pax per segment
  if (anc.seats) extras += Object.values(anc.seats).reduce((s, v) => s + (v?.price || 0), 0);
  if (anc.bags) extras += Object.values(anc.bags).reduce((s, v) => s + (v?.totalPrice || 0), 0);
  if (anc.meals) extras += Object.values(anc.meals).reduce((s, v) => s + (v?.totalPrice || 0), 0);
  if (anc.insurance) extras += (anc.insurance.price || 0) * pax;
  return Math.round((baseAir + extras) * 100) / 100;
}
